import * as React from 'react';
import { cn } from '../../utils/cn/cn';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Payload rendered inside the badge indicator (for example a numeric counter or short label). */
  badgeContent: React.ReactNode;
  /** Optional className for the badge content span element to customize positioning and styling */
  badgeContentClassName?: string;
}

export const Badge = ({
  className,
  children,
  badgeContent,
  badgeContentClassName,
  ...props
}: BadgeProps) => (
  <div className={cn('relative inline-flex align-middle', className)} {...props}>
    {children}
    <span
      className={cn(
        'bg-color-primary text-size-body-xs text-color-primary-contrasttext absolute top-0 right-0 box-border flex h-2 min-w-2 origin-top-right translate-x-1/2 -translate-y-1/2 flex-row flex-wrap items-center justify-center rounded-full px-0.5 whitespace-nowrap',
        badgeContentClassName,
      )}
    >
      {badgeContent}
    </span>
  </div>
);
